import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { type IconProp } from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'rcp-button-icon-only',
  template: `
    <button
      class="rcp-button"
      [class.primary]="color() === 'primary'"
      [class.alert]="color() === 'alert'"
      [class.guaranteed-on-dark]="color() === 'guaranteed-on-dark'"
      [class.secondary-guaranteed-on-light]="color() === 'secondary-guaranteed-on-light'"
      [class.disabled]="disabled()"
      [class.active]="active()"
    >
      <span class="button-icon">
        <fa-icon [icon]="icon()" />
      </span>
    </button>
  `,
  styleUrls: ['./button-icon-only.component.scss'],
  imports: [FontAwesomeModule],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ButtonIconOnlyComponent {
  readonly icon = input.required<IconProp>();
  readonly color = input<
    'primary' | 'alert' | 'guaranteed-on-dark' | 'guaranteed-on-light' | 'secondary-guaranteed-on-light'
  >();
  readonly active = input(false);
  readonly disabled = input(false);
}
